'use client';
import { Button } from '@/components/ui/buttons';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import ReturnModal from './modals/return-product';
import RateModal from './modals/rate-product';
import { toast } from 'sonner';
import { returnProducts, reviewProduct } from '@/services/user/orders';
import { useSession } from 'next-auth/react';

const defaultState = {
  isOpenRate: false,
  isLoadingRate: false,
  isOpenReturn: false,
  isLoadingReturn: false,
};
function CardActions({ product, mage }) {
  const t = useTranslations('');
  const { data: session } = useSession();

  // Combined modal states for better management
  const [modalState, setModalState] = useState(defaultState);

  const toggleModal = (type, state) => {
    setModalState((prev) => ({ ...prev, [type]: state }));
  };

  const onRate = async (desc) => {
    toggleModal('isLoadingRate', true);
    try {
      const res = await reviewProduct({
        mage,
        user: session?.user,
        rate: 1,
        desc,
        product_id: product?.product_id,
      });
      if (res.status == 200) {
        toast.success(t(res?.data?.message));
      }
    } catch (err) {
      toast.error(err?.message || t('common.unknwen_error_key'));
    } finally {
      setModalState(defaultState);
    }
  };

  const onReturn = async () => {
    toggleModal('isLoadingReturn', true);
    try {
      const res = await returnProducts({
        mage,
        orderId: product?.order_id,
        items: [product?.item_id],
      });
      if (res.status == 200) {
        toast.success(t('user.return_request_sent_to_admin'));
      } else {
        toast.error(t('user.return_request_failed'));
      }
    } catch (err) {
      toast.error(err?.message || "Can't return product");
    } finally {
      setModalState(defaultState);
    }
  };

  return (
    <>
      <div className='mb-3 flex items-center gap-2 max-lg:gap-3 max-sm:grid max-sm:grid-cols-2 sm:absolute sm:end-0 sm:top-1/2 sm:w-1/2 sm:justify-end'>
        <Button
          onClick={() => toggleModal('isOpenReturn', true)}
          className='border-primary h-7.5 w-full border max-lg:text-sm max-sm:text-xs max-sm:font-bold sm:w-[161px] md:h-9 lg:h-10'
        >
          {t('user.return_key')}
        </Button>

        <Button
          onClick={() => toggleModal('isOpenRate', true)}
          className='!text-primary h-7.5 w-full border border-black bg-white hover:!text-white max-lg:text-sm max-sm:text-xs max-sm:font-bold max-sm:!text-black sm:w-[161px] md:h-9 lg:h-10'
        >
          {t('user.rate_product_key')}
        </Button>
      </div>

      {modalState.isOpenRate && (
        <RateModal
          product={product}
          isOpen={modalState.isOpenRate}
          onClose={() => toggleModal('isOpenRate', false)}
          isLoading={modalState.isLoadingRate}
          onRate={onRate}
        />
      )}

      {modalState.isOpenReturn && (
        <ReturnModal
          isOpen={modalState.isOpenReturn}
          onClose={() => toggleModal('isOpenReturn', false)}
          isLoading={modalState.isLoadingReturn}
          onReturn={onReturn}
        />
      )}
    </>
  );
}

export default CardActions;
